import ProductAjaxService from "./ProductAjaxService";

export default class AwaytActions extends ProductAjaxService {
    constructor() {
        super();
        this.addToAwayt()
        this.removeFromAway()
    }

    addToAwayt() {
        let self = this;
        $(document).on('click', '.add_to_away:not(.disabled)', function (e) {
            e.preventDefault();

            let ID = $(this).attr('data-id');
            if(!ID) {
                console.warn('Please set product ID');
                return false;
            }
            self._POST(self.addToAwayUrl, {product_id: ID}, self.showStatus);
            $('.add_to_away[data-id='+ ID +']').addClass('active disabled');
        });
    }

    removeFromAway() {
        let self = this;
        $(document).on('click', '.delete_from_away', function (e) {
            e.preventDefault();

            let ID = $(this).attr('data-id');
            if(!ID) {
                console.warn('Please set product ID');
                return false;
            }
            self._POST(self.deleteToAwayUrl, {product_id: ID}, self.afterDelete);
            $('.delete_from_away[data-id="'+ ID +'"]').parent().remove();
        });
    }

    afterDelete(res) {
        if(res.success) {
            if(!res.data.count || res.data.count === 0) {
                $('#xhr-awaite-list').remove();
            }
        }
    }

    showStatus(res) {
        if(res.success) {
            $(document).trigger('trigger.show.popup', ['#report_availability']);
            return true;
        }
        alert('Ooops!');
    }
}
